import { normalizeColorToSemantic } from '@/shared/config'
import { selectListSystemKey, useAppSelector } from '@/shared/redux'
import { useCallback, useMemo } from 'react'
import { getSystemKeyColor, getSystemKeyDescription } from '../lib/systemkey'
import { getNumberOptionsByKey } from '../lib/systemkey-options'

export interface SystemKeyStatusOption {
  value: number
  label: string
  /** Màu semantic (`default | processing | warning | success | error | purple | cyan`). */
  color: string
}

/**
 * Nhãn và màu của một nhóm systemkey (R-112). Dùng cho enum BE hiển thị dạng tag/badge.
 * Chưa nạp systemkey hoặc nhóm chưa có → `options` rỗng, `getLabel` trả chuỗi rỗng,
 * `getColor` trả `default`. Không có fallback đủ bộ.
 */
export function useSystemKeyStatus(key: string) {
  const listSystemKey = useAppSelector(selectListSystemKey)

  const options = useMemo<SystemKeyStatusOption[]>(
    () =>
      getNumberOptionsByKey(key, listSystemKey).map((opt) => ({
        ...opt,
        color: getSystemKeyColor(key, opt.value, listSystemKey),
      })),
    [key, listSystemKey]
  )

  const getLabel = useCallback(
    (value: number | string | null | undefined): string =>
      getSystemKeyDescription(key, value, listSystemKey, ''),
    [key, listSystemKey]
  )

  const getColor = useCallback(
    (value: number | string | null | undefined): string =>
      normalizeColorToSemantic(getSystemKeyColor(key, value, listSystemKey)),
    [key, listSystemKey]
  )

  return { options, getLabel, getColor }
}
